import { configureStore } from '@reduxjs/toolkit';
import filters from './slices/filters';
import oils from './slices/oils';

export const store = configureStore({
  reducer: { filters, oils },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDiscpatch = typeof store.dispatch;
